import { CarTableMultiRow } from "@app/components/Table";
import { columns } from "./RealEstateColumns";
import { RealEstateRowProps } from "./real-estate-types";
import { memo } from "react";
import { setDisplayName } from "@app/utils";

export const RealEstateRowRental = memo((props: RealEstateRowProps) => (
  <CarTableMultiRow
    className={props.className}
    item={props.item}
    rows={[
      [
        columns.realEstateType,
        columns.description,
        columns.realEstateValue,
        columns.costBasis,
        columns.mortgageBalance,
        columns.interestRate,
        columns.sellDate,
      ],
      [
        columns.piPayment,
        columns.monthlyTotalPayment,
        columns.maturityYear,
        columns.monthlyRentalIncome,
        columns.monthlyExpenses,
        columns.monthlyDepreciation,
      ],
      [columns.simulatedInflAdjRent, columns.simulatedInflAdjExpenses],
      [
        columns.secondMortgage,
        ...(props.item.refinance_data
          ? [
              columns.secondMortgageAmount,
              columns.secondMortgageStartDate,
              columns.secondMortgageInterestRate,
              columns.secondMortgageLoadDuration,
            ]
          : []),
      ],
    ]}
    onChange={props.onChange}
    onDelete={props.onDelete}
    pendoPrefix={props.pendoPrefix}
  />
));

setDisplayName({ RealEstateRowRental });
